import { Box, Button } from '@mui/material';
import { Title, Text } from './styles';

export const PageErrorBoundary = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '98vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '30px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: '30px',
        }}
      >
        <Title>Página não encontrada</Title>
        <Text>
          Abaixo estão algumas possíveis causas:
          <br />
          <br /> • A conexão de internet pode estar instável ou interrompida.
          <br /> • A página pode estar temporariamente indisponível devido a
          manutenção ou atualização. <br />• O servidor pode estar enfrentando
          instabilidades.
          <br /> <br />
          Se o problema persistir, entre em contato conosco.
        </Text>
        <Button
          variant="outlined"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '6px 16px',
            width: '219px',
            height: '52px',
          }}
          onClick={() => window.location.reload()}
        >
          Voltar ao início
        </Button>
      </Box>
    </Box>
  );
};
